'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { useCacheKey, useDeviceType, useOptimizely } from '../hooks';
import { resolveScripts } from './scripts.registry';
type ScriptsProps = {
  pageType: string;
};
export const Scripts = t0 => {
  const $ = _c(13);
  const {
    pageType
  } = t0;
  const {
    init
  } = useOptimizely();
  const {
    cookies
  } = useCacheKey();
  const pathname = usePathname();
  const {
    deviceType
  } = useDeviceType();
  const scriptEntries = resolveScripts(pageType);
  let t1;
  if ($[0] !== cookies) {
    t1 = cookies.get("x-petm-team");
    $[0] = cookies;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const team = t1;
  let t2;
  if ($[2] !== deviceType || $[3] !== init || $[4] !== pathname || $[5] !== team) {
    t2 = () => {
      if (pathname) {
        init({
          pathname,
          deviceType,
          team
        });
      }
    };
    $[2] = deviceType;
    $[3] = init;
    $[4] = pathname;
    $[5] = team;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== deviceType || $[8] !== init || $[9] !== pathname) {
    t3 = [init, pathname, deviceType];
    $[7] = deviceType;
    $[8] = init;
    $[9] = pathname;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useEffect(t2, t3);
  const t4 = scriptEntries.map(_temp);
  let t5;
  if ($[11] !== t4) {
    t5 = <>{t4}</>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
function _temp(t0) {
  const {
    id,
    Component
  } = t0;
  return <Component key={id} />;
}